function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: rgba(50, 50, 50, 0.8);\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 50px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
var Overlay = styled.div(_templateObject());
var Content = styled.div(_templateObject1());
export default function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return /*#__PURE__*/ React.createElement(Overlay, {
        "data-testid": props["data-testid"]
    }, /*#__PURE__*/ React.createElement(Content, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "#fff",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: ".25",
        d: "M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z",
        transform: "rotate(218.551 16 16)"
    }, /*#__PURE__*/ React.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 16 16",
        to: "360 16 16",
        dur: "0.8s",
        repeatCount: "indefinite"
    })))));
};
